const action = {
    sign_in: 'Conectează-te',
    continue: 'Continuă',
    create_account: 'Creează cont',
    create_account_without_linking: 'Creează unul nou în schimb',
    create: 'Creează',
    enter_passcode: 'Introdu codul de verificare',
    confirm: 'Confirmă',
    cancel: 'Anulează',
    save_password: 'Salvează parola',
    bind: 'Asociază cu {{address}}',
    bind_and_continue: 'Asociază și continuă',
    back: 'Înapoi',
    nav_back: 'Înapoi',
    nav_skip: 'Omite',
    agree: 'De acord',
    got_it: 'Am înțeles',
    sign_in_with: 'Continuă cu {{name}}',
    forgot_password: 'Ai uitat parola?',
    switch_to: 'Schimbă la {{method}}',
    sign_in_via_passcode: 'Conectează-te cu cod de verificare',
    sign_in_via_password: 'Conectează-te cu parolă',
    change: 'Schimbă {{method}}',
    link_another_email: 'Asociază un alt email',
    link_another_phone: 'Asociază un alt număr de telefon',
    link_another_email_or_phone: 'Asociază un alt email sau telefon',
    show_password: 'Afișează parola',
    copy: 'Copiază',
    verify_via_passkey: 'Verifică prin cheie de acces',
    download: 'Descarcă',
    single_sign_on: 'Autentificare unică',
    authorize: 'Autorizează',
    use_another_account: 'Folosește un alt cont',
};
export default Object.freeze(action);
